import { render, staticRenderFns } from "./licence.vue?vue&type=template&id=8609434e&scoped=true&"
import script from "./licence.vue?vue&type=script&lang=js&"
export * from "./licence.vue?vue&type=script&lang=js&"
import style0 from "./licence.vue?vue&type=style&index=0&id=8609434e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8609434e",
  null
  
)

export default component.exports